<template>
    <div id="footer">
        <div class="container">
            <div class="row">
            <div class="col-sm">
                <img id="jallallaFooter" src="../assets/Jallalla.png" alt="">
            </div>
                <div class="col-sm">
                    <h4 class="title-footer">Hablanos</h4>
                        <a class="btn btn-social mx-1" target="_blank" href="https://www.facebook.com/jallallaSD"><i class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-social mx-1" target="_blank" href="mailto:jallallasd@gmail.com"><i class="far fa-envelope"></i></a>
                        <a class="btn btn-social mx-1" target="_blank" href="https://www.instagram.com/jallallasd/"><i class="fab fa-fw fa-instagram"></i></a>
                </div>
                <div class="col-sm">
                    <div class="footerPhrase">
                    <span>"Sólo quiero tener leones en mi regimiento."<br>-<br>San Martín</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Footer",
}
</script>

<style>
#footer{
    padding: 30px 0 20px 0;
    background: #E50051;
}

.footerPhrase{
    border-radius: 30px;
    border:#000000 solid 2px;
    padding: 10px;
}

#jallallaFooter{
    width: 50%;
    border: #000000 solid 2px;
    border-radius: 30px; 
}

.col-sm{
    padding-bottom: 30px;
}

.title-footer{
    margin-bottom: 1rem;
}

.fab{
    color: #000000;
}

.btn-social{
    border-radius: 100%;
    display: inline-flex;
    width: 3.25rem;
    height: 3.25rem;
    font-size: 1.25rem;
    color: #000000;
    border: 2px solid #000000;
    transition: all 200ms ease;
    justify-content: center;
    align-items: center;
}
.btn-social:hover{
    background: #F9B256;
    border: 2px solid #000000;
    color: #000000;
}


</style>